module.exports = __webpack_public_path__ + "static/media/ic-mobile.4ab9580e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-mobile.svg
// module id = 643
// module chunks = 14